module.exports = __webpack_public_path__ + "static/media/Growslab1.55049787.webp";